module.exports = __webpack_public_path__ + "static/media/mainBgYellow.cd06d774.png";